
export const GetTextColor = (bgColor) => {
    if (!bgColor) return "black";

    // If the bgColor starts with a hash, remove it
    if (bgColor.indexOf('#') === 0) bgColor = bgColor.slice(1);

    const r = parseInt(bgColor.slice(0, 2), 16);
    const g = parseInt(bgColor.slice(2, 4), 16);
    const b = parseInt(bgColor.slice(4, 6), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    //Previously 128
    return yiq >= 177 ? 'black' : 'white';
}

export const GetTextColorAlt = (pageBgColor, itemBgColor, opacity) => {
    if (!itemBgColor) return "black";

    // If the colors start with a hash, remove it
    if (itemBgColor.indexOf('#') === 0) itemBgColor = itemBgColor.slice(1);
    if (pageBgColor.indexOf('#') === 0) pageBgColor = pageBgColor.slice(1);

    // Parse RGB values of both colors
    const itemR = parseInt(itemBgColor.slice(0, 2), 16);
    const itemG = parseInt(itemBgColor.slice(2, 4), 16);
    const itemB = parseInt(itemBgColor.slice(4, 6), 16);

    const pageR = parseInt(pageBgColor.slice(0, 2), 16);
    const pageG = parseInt(pageBgColor.slice(2, 4), 16);
    const pageB = parseInt(pageBgColor.slice(4, 6), 16);

    // Calculate perceived color
    const perceivedR = Math.round(itemR * opacity + pageR * (1 - opacity));
    const perceivedG = Math.round(itemG * opacity + pageG * (1 - opacity));
    const perceivedB = Math.round(itemB * opacity + pageB * (1 - opacity));

    const yiq = (perceivedR * 299 + perceivedG * 587 + perceivedB * 114) / 1000;

    return yiq >= 177 ? 'black' : 'white';
}


export const HexToRGBA = (hexColor, opacity) => {
    // If the hex color starts with a hash, remove it
    if (hexColor.indexOf('#') === 0) hexColor = hexColor.slice(1);

    const r = parseInt(hexColor.slice(0, 2), 16);
    const g = parseInt(hexColor.slice(2, 4), 16);
    const b = parseInt(hexColor.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export const LightenColor = (color, shadeFactor) => {
    if (!/^#[0-9A-F]{6}$/i.test(color)) {
        return '#FFFFFF';
    }

    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    const newR = Math.round(r + (255 - r) * shadeFactor).toString(16).padStart(2, '0');
    const newG = Math.round(g + (255 - g) * shadeFactor).toString(16).padStart(2, '0');
    const newB = Math.round(b + (255 - b) * shadeFactor).toString(16).padStart(2, '0');

    return '#' + newR + newG + newB;
}